import prefooterlarge from "_texts/presentation/prefooters/prefooterlarge.js";

const textProps = {
  ...prefooterlarge,
  type: "dark",
};
export default textProps;
